<template>
  <div
    class="Line2Charts"
    ref="loading-box"
    v-loading="loading"
    element-loading-text="拼命加载中..."
    element-loading-background="rgba(0, 0, 0, 0)"
    :class="getStyle('title')"
  >
    <DateDropDownSelect
      v-if="value.isShowRightDropDownBox"
      :selectData="selectData"
      :selectApi="selectApi"
      @selectChange="selectChange"
    >
    </DateDropDownSelect>
    <div
      class="echarts"
      v-show="charData"
      :id="Configuration.id"
      style="z-index: 1"
      @mousedown="handleEchartsTap"
    ></div>
    <div class="no-data" v-show="noData">
      <sapn>暂无数据!</sapn>
    </div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import { getFilterValue } from '../../../../utils/tool.js';
import DateDropDownSelect from '@/components/common/DateDropDownSelect/DateDropDownSelect.vue';
import { request } from '../../../../common/request';
export default {
  name: 'Line2Charts',
  components: { DateDropDownSelect },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      DataProcessing: null,
      echartsClickData: '',
      echartsClick: '',
      dataZoom: {},
      value: {
        isShowRightDropDownBox: false,
      },
      ChartsBottomData: {
        // 图表拖动数据条
        isShowRightOpen: false,
      },
      selectData: [], // 下拉选择的时间数据
      selectApi: '',
      params: {}, // 请求参数
      paramsCopy: {},
      noData: false, // 无数据
      charData: true,
      loading: true,
      timer: null,
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        // console.log(this.Configuration, 'this.Configuration');
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    // this.getApiDataResByFilterAndResponseQuery();
    this.LocalChartDataProcessing();
    this.setStyle();
    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    // 判断 数据 为本地或动态
    this.selectApi = ChartsData;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    console.log(this.params, 'aaaaaaaaa');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  methods: {
    // 图表 刷新 静态数据
    handleChange(val) {
      // console.log(val, 'valvalval');
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: 'ChartsData',
        value: val,
      });
    },
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          style = {};
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V10Style':
          style = {};
          if (bool) style['V10StyleTitle'] = true;
          style['V10Style'] = true;
          break;
        case 'V11Style':
          style = {};
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        case 'V12Style':
          style = {};
          if (bool) style['V12StyleTitle'] = true;
          style['V12Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    valueProcessors() {
      return {
        date: value => ({ data: value }),
        string: value => ({ param: value }),
        number: value => ({ date: value.toString() }),
        month: value => ({ kind: 'month' }),
        dateRange: value => {
          const [year, month] = value.split('-');
          const startDate = `${year}-${month}-01`;
          const lastDay = new Date(year, month, 0).getDate(); // Get the last day of the month
          const endDate = `${year}-${month}-${lastDay}`; // Use the last day of the month
          return { start_date: startDate, end_date: endDate };
        },
        year: value => ({ year: value, date: value }), // New processor for years
        arrayDateRange: value => {
          const [_, startDate, endDate] = value; // Extract the second and third elements
          return { start_date: startDate, end_date: endDate };
        },
        // Add more mappings as needed
      };
    },
    getValueType(value) {
      if (Array.isArray(value) && value.length === 3) {
        return 'arrayDateRange'; // Example: ['timekey', '2025-04-01', '2025-04-30']
      } else if (/[A-Za-z]+$/.test(value)) {
        return 'month'; // Example: 'month' is a string
      } else if (/^[\u4e00-\u9fa5]+$/.test(value)) {
        return 'string'; // Example: Chinese characters
      } else if (!isNaN(value) && value.length === 4) {
        return 'year'; // Example: '2025'
      } else if (!isNaN(value)) {
        return 'number'; // Example: '2023' or '123'
      } else if (/^\d{4}-\d{2}$/.test(value)) {
        return 'dateRange'; // Example: '2025-03'
      } else {
        return 'date'; // Example: '2025-03-01'
      }
    },
    /**新增功能start */
    selectChange(e) {
      console.log(e, 'selectChange');
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;

      if (ChartsData?.currenEntry === 'staticData') {
        this.echartsClick = e;
        this.asyncLocalDatatest();
      } else {
        this.params = getFilterValue(e);
        this.startApiIntervalTask();
      }
    },
    removeLeadingZeros(str) {
      // 将字符串转换为Number类型，然后再转换回String类型，这样会自动去除前导零
      let num = Number(str);

      if (num < 10) {
        return str.slice(1);
      } else {
        return str;
      }
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    getParams(date) {
      let params = {};
      if (Object.keys(this.paramsCopy).length != 0) {
        Object.keys(this.paramsCopy).forEach(key => {
          params[key] = '';
        });
        Object.keys(params).forEach(key => {
          console.log(key, 'key   key');
          if (key.indexOf('start') != -1 || key.indexOf('Start') != -1) {
            params[key] = date + '-01';
            // params[key] = date
          } else {
            if (date.indexOf('-') == -1) {
              // 年
              params[key] = date + '-12';
              // params[key] = date
            } else {
              params[key] = date + '-' + getFullDayOfOneMonth(date);
            }
          }
        });
      }

      function getFullDayOfOneMonth(date) {
        let arr = date.split('-');
        return new Date(arr[0], arr[1], 0).getDate();
      }

      return params;
    },
    getSourceYearAndMonth(source, flag, param = 'x', index = 1, splitChar = '-') {
      let result = '';
      if (flag == 'year') {
        // 形如2020-01-02
        if (source[0][param].indexOf(splitChar) != -1) {
          // 最后加上slice是为了防止有形如2020年-1月-1日的数据
          result = source[0][param].split(splitChar)[index].slice(0, 4);
        } else {
          // 形如2020年
          result = source[0][param].slice(0, 4);
        }
      } else if (flag == 'month') {
        result = source[0][param].split(splitChar)[index];
      }
      return result;
    },
    /**新增功能end */
    // 根据不同的风格取不同的颜色
    setStyle() {
      let color;
      switch (this.style) {
        case 'V1Style':
          color = '#eee';
          break;
        case 'V2Style':
          color = '#eee';
          break;
        case 'V3Style':
          color = '#7fdfff';
          break;
        case 'V4Style':
          color = '#b044f8';
          break;
        case 'V5Style':
          color = '#09af60';
          break;
        default:
          color = '#eee';
          break;
      }
      this.$refs['loading-box'].style.setProperty('--color', color); // 给变量赋值
    },
    handleEchartsTap(e) {
      // e.stopPropagation();
    },
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    async asyncLocalDatatest() {
      let refs = await this.LocalChartDataProcessing();
      let datestr = this.echartsClick;
      let LocalData = refs.data;
      let timeData = {
        staticData: LocalData[datestr],
      };
      this.handleChange(timeData);
    },
    setEchartsOptions(ParamData = null) {
      console.log(ParamData, 'sgvdabgadsfbsdbd');

      if (Object.keys(ParamData).length == 0 || ParamData.source.length == 0) {
        this.noData = true;
        this.charData = false;
      } else {
        this.noData = false;
        this.charData = true;
      }
      let grid = {};
      let color = [];
      let source = [];
      let cUnit = {};
      let unit = '';
      let gradient = '';
      let seriesList = [];
      let useYear = ''; // 年份 使用哪个维度的可以做时间，默认为x（有时需要s）
      let yearIndex = 0; // 年份以'-'分割后取第几个
      let useMonth = ''; // 月份 使用哪个维度的可以做时间，默认为x（有时需要s）
      let monthIndex = 0; // 月份 有时候是2020-01-01，或者是03-01，所以得指定分割后的下标
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };
      let dropDownData = []; // 下拉 数组 数据
      let dropDownNumberData = [];
      let echartsDataStyle = 'default';
      let dropDownDataYear = ['2020', '2021'];
      let dropDownDataMonth = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        color = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (this.Configuration.propertyData?.chartUnit?.value) {
        unit = this.Configuration.propertyData.chartUnit.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;

        dropDownDataYear = ParamData?.dropDownDataYear;
        dropDownDataMonth = ParamData?.dropDownDataMonth;
        useYear = ParamData?.useYear;
        yearIndex = ParamData?.yearIndex;
        useMonth = ParamData?.useMonth;
        monthIndex = ParamData?.monthIndex;

        dropDownData = ParamData?.dropDownData; //ParamData里 下拉 数组 数据
        dropDownNumberData = ParamData?.dropDownNumberData;
      }

      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      if (this.Configuration.propertyData?.chartsRightDropDown?.value) {
        this.value = this.Configuration.propertyData.chartsRightDropDown.value;
      }
      if (this.Configuration.propertyData?.chartsRightDragDisplayBar?.value) {
        this.ChartsBottomData = this.Configuration.propertyData.chartsRightDragDisplayBar.value;
      }
      if (this.Configuration.propertyData.chartsUnit?.value) {
        cUnit = this.Configuration.propertyData.chartsUnit.value;
      }

      let that = this;
      function dealSelectData() {
        let selectData = [];
        let yearData = [];
        let monthData = [];

        if (dropDownDataYear) {
          dropDownDataYear.forEach(item => {
            yearData.push({
              label: item + '年',
              value: item,
            });
          });
          selectData.push({
            flag: 'y',
            modelValue: that.getSourceYearAndMonth(source, 'year', useYear, yearIndex),
            data: yearData,
          });
        }
        if (dropDownDataMonth) {
          dropDownDataMonth.forEach(item => {
            monthData.push({
              label: item + '月',
              value: item.toString().length == 2 ? item : item.toString().padStart(2, '0'),
            });
          });
          selectData.push({
            flag: 'm',
            modelValue: that.getSourceYearAndMonth(source, 'month', useMonth, monthIndex),
            data: monthData,
          });
        }
        if (dropDownData) {
          // 遍历 dropDownData
          dropDownData.forEach(item_f => {
            let child = [];
            //
            if (item_f[3]) {
              item_f[3].forEach(item_c => {
                child.push({
                  label: item_c[0],
                  value: item_c[1],
                });
              });
            }
            if (item_f[2] != undefined && child.length == 0) {
              selectData.push({
                label: item_f[0],
                value: item_f[1],
                modelValue: item_f[2],
              });
            } else if (item_f[2] == undefined && child.length == 0) {
              selectData.push({
                label: item_f[0],
                value: item_f[1],
              });
            } else {
              selectData.push({
                label: item_f[0],
                value: item_f[1],
                modelValue: item_f[2],
                children: child,
              });
            }
          });
        }
        if (dropDownNumberData) {
          dropDownNumberData.forEach(Years => {
            let child = [];
            // 子 一月 二月... 判断
            if (Years[3]) {
              Years[3].forEach(item_D => {
                //  判断 是否有出现 展示第3个下拉框的标识
                if (item_D[2] != undefined && item_D[2] != null) {
                  child.push({
                    label: item_D[0] + '月',
                    value: item_D[1],
                    // 需要出现 日 时
                    third: item_D[2],
                  });
                } else {
                  child.push({
                    label: item_D[0] + '月',
                    value: item_D[1],
                  });
                }
              });
            }
            // 父 不为空
            if (Years[0] != undefined && child.length != 0) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
                children: child,
              });
            } else if (Years[0] != undefined) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
              });
            }
          });
        }

        that.selectData = selectData;
      }

      if (this.value.isShowRightDropDownBox) {
        dealSelectData();
      }
      let xAxis_data = [];
      let series = [];
      function DealData() {
        seriesList.forEach((s, index) => {
          let cate = {
            name: s,
            type: 'line',
            barWidth: '28%',
            data: [],
            areaStyle: {
              // global: false, // 缺省为 false
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 0.9,
                colorStops: [
                  {
                    offset: 0,
                    color: color[index], // 0% 处的颜色
                  },
                  {
                    offset: 0.2,
                    color: color[index].replace('1)', '0.5)'), // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: color[index].replace('1)', '0)'), // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            itemStyle: {
              color: color[index],
              borderColor: color[index], // 描边颜色
              borderWidth: 1,
              // normal: {
              //   barBorderRadius: 0,
              //   color: new Echarts.graphic.LinearGradient(
              //     0,
              //     0,
              //     0,
              //     1,
              //     [
              //       { offset: 0, color: color[index] }, // 设置颜色渐变
              //       { offset: 0.5, color: color[index].replace('1)', '0.5)') }, // 设置颜色渐变
              //       { offset: 1, color: color[index].replace('1)', '0)') },
              //     ],
              //     false,
              //   ),
              // },
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: '#a5a5a5',
              },
            },
            smooth: true,
            barGap: '100%',
          };
          source.forEach(item => {
            xAxis_data.push(item.x);
            if (s === item.s) {
              cate.data.push(item.y);
            }
          });
          series.push(cate);
        });
        xAxis_data = [...new Set(xAxis_data)];
      }
      DealData();

      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        color: color,
        tooltip: {
          className: 'echarts-tooltip echarts-tooltip-dark',
          textStyle: {
            color: '#7d7c94',
            fontSize: this.$h_Ratio(15, this.$store),
          },
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          ...grid,
          containLabel: true,
        },
        legend: {
          show: !this.value.isShowRightDropDownBox,
          right: 10,
          top: 0,
          textStyle: {
            color: '#7d7c94',
            fontSize: this.$h_Ratio(18, this.$store),
          },
          itemWidth: 12,
          itemHeight: 10,
        },
        xAxis: {
          type: 'category',
          data: xAxis_data,
          axisLine: {
            lineStyle: {
              color: fontStyle.xAxisColor, // 横 坐标刻度 也是
            },
          },
          axisLabel: {
            color: fontStyle.xAxisColor, //坐标轴文字颜色
            fontSize: this.$h_Ratio(fontStyle.xAxisSize, this.$store),
            textStyle: {
              fontFamily: 'Microsoft YaHei',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: 'white',
            },
          },
          name: unit,
          nameTextStyle: {
            nameLocation: 'start',
            color: '#fff',
            fontSize: this.$h_Ratio(12, this.$store),
            padding: [cUnit.top, cUnit.right, cUnit.bottom, cUnit.left],
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#9d9d9dbf', // 竖 坐标线
            },
          },
          axisLabel: {
            color: fontStyle.yAxisColor, // 竖 坐标轴 文字颜色
            fontSize: this.$h_Ratio(fontStyle.yAxisSize, this.$store), //更改坐标轴文字大小
          },
        },
        dataZoom: [
          {
            show: this.ChartsBottomData.isShowRightOpen,
            height: this.$h_Ratio(20, this.$store),
            xAxisIndex: [0],
            realtime: true,
            bottom: '8%',
            start: this.ChartsBottomData.isShowRightOpen ? 35 : 0,
            end: 100,
          },
          {
            type: 'inside',
            show: this.ChartsBottomData.isShowRightOpen,
            height: this.$h_Ratio(20, this.$store),
            start: this.ChartsBottomData.isShowRightOpen ? 35 : 0,
            end: 100,
          },
        ],
        series: series,
      };
      // 关闭加载
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.staticIntervalTaskID = setTimeout(() => {
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        // console.log(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 本地下拉数据切换处理
    LocalChartDataProcessing() {
      return new Promise((resolve, reject) => {
        this.axios
          .get('/chartsData.json')
          .then(res => {
            this.DataProcessing = res;
            let data = this.$_.cloneDeep(res);
            // console.log(data, 'LocalChartDataProcessing');
            resolve(data);
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      clearInterval(this.apiIntervalTaskID);
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setTimeout(async () => {
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        console.log(ChartsData?.apiData?.apiInterval, 'ChartsData?.apiData?.apiInterval');
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');
          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   params: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          // let params = ChartsData.apiData.apiPostParams || {};
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              console.log(arryQuery, 'arryQuery arryQuery');
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            // console.log(ChartsData.apiData, 'ChartsData.apiData');
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');

      let echartsOptions = this.echartsOptions;

      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },

  Configuration: {
    componentTitle: '大数据曲线堆叠面积图',
    componentName: 'Line2Charts',
    componentOverViewImg: './img/charts/LineCharts/Line2Charts.png',
    id: '',
    style: {
      width: 300,
      height: 150,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
            apiUrlMethod: 'get',
            apiPostParams: '',
          },
          staticData: {
            seriesList: ['杭州市', '太原市', '北京市'],
            source: [
              {
                s: '杭州市',
                x: '2021-05-21',
                y: '25',
                i: 1,
              },
              {
                s: '杭州市',
                x: '2021-05-22',
                y: '26',
                i: 2,
              },
              {
                s: '杭州市',
                x: '2021-05-23',
                y: '20',
                i: 3,
              },
              {
                s: '杭州市',
                x: '2021-05-24',
                y: '27',
                i: 4,
              },

              {
                s: '太原市',
                x: '2021-05-21',
                y: '25',
                i: 1,
              },
              {
                s: '太原市',
                x: '2021-05-22',
                y: '26',
                i: 2,
              },
              {
                s: '太原市',
                x: '2021-05-23',
                y: '20',
                i: 3,
              },
              {
                s: '太原市',
                x: '2021-05-24',
                y: '27',
                i: 4,
              },

              {
                s: '北京市',
                x: '2021-05-21',
                y: '25',
                i: 1,
              },
              {
                s: '北京市',
                x: '2021-05-22',
                y: '26',
                i: 2,
              },
              {
                s: '北京市',
                x: '2021-05-23',
                y: '20',
                i: 3,
              },
              {
                s: '北京市',
                x: '2021-05-24',
                y: '27',
                i: 4,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 150,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '5%',
          bottom: '17%',
          top: '12%',
        },
      },
      chartsUnit: {
        lable: '单位定位',
        propertyComponentName: 'ChartsUnitConfiger',
        value: {
          left: '10',
          right: '0',
          bottom: '0',
          top: '0',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartUnit: {
        propertyComponentName: 'MapChartUnit',
        value: '单位(张)',
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 3,
        },
      },
      chartsRightDropDown: {
        propertyComponentName: 'ChartsRightDropDownConfiger',
        value: {
          isShowRightDropDownBox: false,
        },
      },
      chartsRightDragDisplayBar: {
        label: '是否开启图表拖动展示条',
        propertyComponentName: 'DataDragDisplayBar',
        value: {
          isShowRightOpen: false,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Line2Charts {
  color: white;
  width: 100%;
  height: 100%;
  position: relative;

  .echarts {
    width: 100%;
    height: 100%;
  }

  .DateDropDownSelect {
    position: absolute;
    top: -20px;
    right: 28px;
    z-index: 10;
  }

  .no-data {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #ccc;
  }
}
.V11Style {
  :deep().dis-block .drop-down-select:nth-child(1) .el-input__inner {
    width: 74px !important;
  }
  :deep().drop-down-select .el-input__inner {
    border: 1px solid #c63a36 !important;
    color: #fff !important;
  }
  .DateDropDownSelect {
    right: 0 !important;
  }
  :deep().el-icon-arrow-up:before {
    color: #fff !important;
  }
}
.V12Style {
  :deep().drop-down-select:nth-child(n + 2) .el-input__inner {
    width: 50px !important;
  }
  :deep().drop-down-select .el-input__inner {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }

  :deep().DateDropDownSelect {
    right: 7px !important;
    top: -14px !important;
  }
}
// 加载样式

:deep().el-loading-spinner {
  .path {
    stroke: var(--color) !important;
  }

  p {
    display: flex !important;
    align-items: center !important;
    color: var(--color) !important;
  }
}
</style>
